import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider } from "./contexts/ThemeContext.jsx";
import { UnsavedChangesProvider } from "./contexts/UnsavedChangesContext.jsx";
import App from "./App.jsx";
import "./styles/styles.scss";

const appRoot = createRoot(document.getElementById("app-root"));
appRoot.render(
  <BrowserRouter>
    <ThemeProvider>
      <UnsavedChangesProvider>
        <App />
      </UnsavedChangesProvider>
    </ThemeProvider>
  </BrowserRouter>
);
